import { useTranslator } from '@Localization';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { S_Alert } from '../../../../design/alert/S_Alert';

interface IProps {
  showPublishedAlert: boolean;
}

export const PublishedProjectInfo = observer((props: IProps): ReactElement => {
  const { t } = useTranslator();
  return (
    <>
      {props.showPublishedAlert && (
        <S_Alert color='info'>
          <strong>{t('info')} </strong>
          {t('this_project_has_been_published')}
        </S_Alert>
      )}
    </>
  );
});
